import { Injectable, Injector } from '@angular/core';
import { WorkFlow } from './types';
import { WorkFlowMessageService } from './work-flow-message.service';

/**
 * å·¥ä½æµæ¶æ¯
 * @warning ç¦æ­¢ä½¿ç¨è¡¨åä¸ä¸æï¼ææä¸ä¸æå¿é¡»ä»å¤é¨ä¼ å¥
 */
@Injectable()
export class WorkFlowMessage {
  private listeners: Map<string, any>;
  constructor(private injector: Injector, public workFlowMessageService: WorkFlowMessageService) {
    this.listeners = new Map<string, any>();
  }
  public setup() {
    if (!this.workFlowMessageService) {
      return;
    }
    this.workFlowMessageService.listen((message: WorkFlow.IMessage) => {
      if (!this.listeners || this.listeners.size < 1) {
        return;
      }
      this.listeners.forEach((callback: any, key: string) => {
        if (typeof callback === 'function') {
          callback(message);
        }
      });
    });
  }
  public addEventListener(callback: (event: MessageEvent) => void): string {
    const id = `${new Date().valueOf().toString(16)}-${Math.ceil(Math.random() * 100)}`;
    this.listeners.set(id, callback);
    return id;
  }
  public removeEventListener(eventId: string): void {
    if (!this.listeners || this.listeners.size < 1) {
      return;
    }
    this.listeners.delete(eventId);
    eventId = null;
  }
}
